import "antd/dist/antd.css";
import "./App.css";
import { useEffect, useState } from "react";
import axios from "axios";
import Particles from "react-tsparticles";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
  withRouter,
} from "react-router-dom";

import Home from "./components/Home";
import CreateMessageForm from "./components/CreateMessageForm";
import MessageCards from "./components/MessageCards";
import PalestineDepartments from "./components/PalestineDepartments";
import particles_params from "./constants/particles-params";
import LanguageSwitcher from "./components/LanguageSwitcher";
import Boycott from "./components/Boycott/index";

const mainLanguage = "ar";
const formattedSupportedLanguages = "(en|ar)";
const supportedLanguages = [
  { name: "عربي", value: "ar" },
  { name: "English", value: "en" },
];

function App() {
  const [messages, setMessages] = useState([]);
  const [currentLanguage, setCurrentLanguage] = useState({
    name: "ar",
    value: "ar",
  });

  useEffect(() => {
    axios
      .get("https://palastine-bk.herokuapp.com/api/v1/messages")
      .then((res) => {
        setMessages(res.data);
      });
  }, []);

  return (
    <Router>
      <div className="App">
        <Particles id="particles-js" params={particles_params} />
        <LanguageSwitcher
          supportedLanguages={supportedLanguages}
          currentLanguage={currentLanguage}
          setCurrentLanguage={setCurrentLanguage}
        />
        <Switch>
          <Route path={`/:lang${formattedSupportedLanguages}/departments`}>
            <PalestineDepartments />
          </Route>
          <Route path={`/:lang${formattedSupportedLanguages}/boycott`}>
            <Boycott />
          </Route>

          <Route path={`/:lang${formattedSupportedLanguages}/create-message`}>
            <CreateMessageForm />
          </Route>
          <Route path={`/:lang${formattedSupportedLanguages}/messageCards`}>
            <MessageCards totalMessages={messages} />
          </Route>
          <Route path={`/:lang${formattedSupportedLanguages}/:id`}>
            <Home totalMessages={messages} />
          </Route>

          <Route path={`/:lang${formattedSupportedLanguages}`}>
            <Home totalMessages={messages} />
          </Route>
          <Route exact path="*">
            <Redirect to={`/${mainLanguage}`} />
          </Route>
        </Switch>
      </div>
    </Router>
  );
}

export default withRouter(App);
